import { motion, useInView } from 'framer-motion';
import { useRef, useEffect, useState } from 'react';

const dolphins = [
  {
    color: "rouge",
    name: "Kalim",
    module: 1,
    title: "La libération des mémoires transgénérationnelles",
    description: "Tu t'ancres profondément et dépasses les dénis d'incarnation, tout en libérant les mémoires familiales.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/09/gilles1385_red_galactic_Dolphin_cosmos_energy_divine_futuriste__757316d6-f200-40bb-b0ad-96096234844e.png"
  },
  {
    color: "orange",
    name: "Shampa Takir",
    module: 2,
    title: "Le déblocage de ton plein potentiel",
    description: "Tu renoues avec l'intelligence de ton corps et actives ton chakra sacré afin d'apprivoiser tes peurs et révéler les trésors cachés en toi.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/09/gilles1385_dauphin_orange_Dolphin_animal_on_first_plan_and_back_09df74af-0066-4a87-80af-166eada9dd41.png"
  },
  {
    color: "jaune",
    name: "Ra Limpaga",
    module: 3,
    title: "La pacification des colères",
    description: "Tu lâches ton besoin contrôle pour passer à l'art de la maîtrise. Cette fréquence te permet d'accueillir et de pacifier une colère intérieure.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/10/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_Yellow_d_70b3a3e7-b643-4643-ab82-3f3056bdcdee.png"
  },
  {
    color: "vert",
    name: "Étoile Atlante",
    module: 4,
    title: "Renforcer son corps et son mental par la respiration",
    description: "Tu entres dans un portail dimensionnel puissant grâce au pouvoir de ta respiration qui va venir renforcer te ramener au moment présent.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_green_da_a98140e4-6ba3-4494-9961-363df18719aa.png"
  },
  {
    color: "rose",
    name: "Shanella",
    module: 5,
    title: "La guérison d'une blessure d'amour",
    description: "Tu te connectes à la conscience de la Mère divine pour vivre une expérience d'amour inconditionnel.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_rose_dau_74da70fd-fc44-4eb5-bc3a-2248cc164c13.png"
  },
  {
    color: "turquoise",
    name: "Logacy",
    module: 6,
    title: "Rencontre avec la joie de ton enfant intérieur",
    description: "Une rencontre émouvante avec ton enfant intérieur et toute la joie, l'innocence et la spontanéité qu'il souhaite exprimer.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_turquois_8cbec288-5125-4e13-8bab-c1d122dcb180.png"
  },
  {
    color: "bleu",
    name: "Extensia",
    module: 7,
    title: "Vivre des relations épanouies grâce à une communication fluide",
    description: "Tu vas agir sur ton chakra de la gorge pour oser t'exprimer et de la meilleure façon qui soit.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_bleu_dau_2f1f455b-76ac-4c23-9567-ce8bc76c7c2e.png"
  },
  {
    color: "indigo",
    name: "Ajna activateur",
    module: 8,
    title: "Activation de ta clairvoyance",
    description: "Tu es prêt·e à recevoir des guidances de ton \"Moi supérieur\". Je vais t'apprendre à te câbler à une source fiable pour recevoir des informations.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_indigo_d_51c6ca3d-1191-436e-be4a-41912420509f.png"
  },
  {
    color: "violet",
    name: "Galimpanem",
    module: 9,
    title: "Comment traverser une période de transition avec plus de sérénité",
    description: "C'est LA fréquence delphique pour t'accompagner lors d'une transition difficile ou d'un nouveau départ.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_violet_d_1528da77-503d-4b09-932a-c40dc1dccfaf.png"
  },
  {
    color: "blanc",
    name: "Sky light",
    module: 10,
    title: "La découverte de ta mission d'âme",
    description: "Cette étape est un cap ! Tu vas vivre un véritable saut quantique qui te permettra de renouer avec ta nature divine et ton plan d'âme.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_white_da_a42dc523-fa81-4471-80c2-b289b761bab4.png"
  },
  {
    color: "arc-en-ciel",
    name: "Rainbow light",
    module: 11,
    title: "La transmutation de tes ombres en lumière",
    description: "Tu vas vivre ce que j'appelle \"des noces alchimiques\" : du plomb à l'or, tu vas vivre une transmutation.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_rainbow__7d49a903-744c-4b40-b335-7a3073a0f6fa.png"
  },
  {
    color: "argent",
    name: "Silver light",
    module: 12,
    title: "Libération de tous tes blocages (conscients ou inconscients)",
    description: "Nettoyage au karcher avec ce dauphin : ses fréquences vont éliminer tout ce qui peut affecter ton bien-être et ton évolution.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_silver_d_738f26d2-3620-4dec-930a-723f453e057d.png"
  },
  {
    color: "or",
    name: "Elashim",
    module: 13,
    title: "Harmonisation de tes corps énergétiques (tes 12 chakras)",
    description: "Ces fréquences vont unifier tous tes chakras et corps subtils afin de te faire toucher à un état de grâce et de protection divine.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_gold_dau_2af41b4c-93fa-4a0d-9f7b-d6944c5572d4.png"
  },
  {
    color: "diamant",
    name: "Diamant",
    module: 14,
    title: "Alignement de ton corps, ton esprit et ton âme",
    description: "Avec cette dernière fréquence, tu harmonises ton corps, ton esprit et ton âme pour atteindre un état de complétude permanente.",
    image: "https://gillesdelieuze.com/wp-content/uploads/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_diamond__568ffd55-e58d-4455-b34f-975c4493bf84.png"
  }
];

const DolphinCard = ({ dolphin }) => (
  <div className="flex-shrink-0 w-[280px] sm:w-[320px] group">
    <div className="luxury-card-gold rounded-2xl overflow-hidden h-full transition-all duration-500 hover:border-accent/50">
      <div className="relative h-48 overflow-hidden">
        <img
          src={dolphin.image}
          alt={`Dauphin ${dolphin.color}`}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-card via-card/50 to-transparent" />
        
        {/* Module badge */}
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 rounded-full bg-accent/30 text-accent text-xs font-body backdrop-blur-sm shadow-gold">
            Module {dolphin.module}
          </span>
        </div>
      </div>

      <div className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-gold-luminous font-display text-sm capitalize">
            Dauphin {dolphin.color}
          </span>
          <span className="text-muted-foreground text-xs">•</span>
          <span className="text-muted-foreground text-xs font-body">{dolphin.name}</span>
        </div>
        
        <h4 className="font-display text-base text-foreground mb-2 leading-tight line-clamp-2">
          {dolphin.title}
        </h4>
        
        <p className="text-muted-foreground font-body text-xs leading-relaxed line-clamp-3">
          {dolphin.description}
        </p>
      </div>
    </div>
  </div>
);

export const FrequenciesSection = () => {
  const ref = useRef(null);
  const scrollRef = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const [isPaused, setIsPaused] = useState(false);

  // Auto-scroll effect
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer || isPaused) return;

    let animationId;
    let scrollPosition = 0;
    const scrollSpeed = 0.5;

    const animate = () => {
      scrollPosition += scrollSpeed;
      
      // Reset when we've scrolled half (since content is duplicated)
      const halfScroll = scrollContainer.scrollWidth / 2;
      if (scrollPosition >= halfScroll) {
        scrollPosition = 0;
      }
      
      scrollContainer.scrollLeft = scrollPosition;
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [isPaused]);

  return (
    <section id="frequences" ref={ref} className="section-padding bg-background-secondary relative overflow-hidden">
      {/* Cosmic background effect */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-accent/5 rounded-full blur-3xl" />
        <div className="absolute inset-0 bg-stellar" />
      </div>

      <div className="container-luxury relative">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto mb-8"
        >
          <span className="text-gold-luminous font-body text-sm tracking-[0.3em] uppercase mb-4 block">
            Phase 1
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-foreground leading-tight mb-6">
            Tu te transformes une fréquence après l'autre grâce à de 
            <span className="text-gradient-gold"> puissants codes quantiques</span>
          </h2>
          <p className="text-lg text-muted-foreground font-body">
            C'est le retour au point 0 : ta nature profonde.
          </p>
        </motion.div>

        {/* Phase info */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.2 }}
          className="glass-card rounded-2xl p-6 md:p-8 mb-12 max-w-4xl mx-auto"
        >
          <p className="text-foreground font-body leading-relaxed mb-4">
            La première partie se déroule à travers <span className="text-gold-luminous font-semibold">14 sessions</span> qui 
            correspondent chacune à une fréquence delphique et à un potentiel de transformation.
          </p>
          <p className="text-muted-foreground font-body text-sm">
            Dans chaque module, tu auras accès à : une méditation, une intégration, un mantra, 
            une géométrie sacrée et des exercices pratiques.
          </p>
        </motion.div>

        {/* Title */}
        <motion.h3
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ delay: 0.3 }}
          className="text-center text-2xl font-display text-foreground mb-8"
        >
          Durant ces <span className="text-gradient-gold">14 modules</span> en ligne, nous verrons :
        </motion.h3>
      </div>

      {/* Horizontal Scrolling Dolphins - Full width */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : {}}
        transition={{ delay: 0.4 }}
        className="relative"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div 
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto pb-4 px-4 scrollbar-hide"
          style={{ 
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch'
          }}
        >
          {/* Duplicate dolphins for infinite scroll effect */}
          {[...dolphins, ...dolphins].map((dolphin, index) => (
            <DolphinCard key={`${dolphin.module}-${index}`} dolphin={dolphin} />
          ))}
        </div>

        {/* Gradient fades */}
        <div className="absolute left-0 top-0 bottom-4 w-20 bg-gradient-to-r from-background-secondary to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-4 w-20 bg-gradient-to-l from-background-secondary to-transparent pointer-events-none" />
      </motion.div>

      <div className="container-luxury relative">
        {/* Closing message */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.6 }}
          className="mt-12 text-center"
        >
          <div className="glass-gold rounded-3xl p-8 md:p-12 max-w-3xl mx-auto shadow-gold">
            <p className="text-lg text-foreground font-body leading-relaxed mb-4">
              Lorsque tu auras fini ce parcours initiatique, tes proches et toi n'en reviendront pas de ton évolution.
            </p>
            <p className="text-muted-foreground font-body">
              Tu feras toujours face à des vagues dans ta vie. Mais cette fois, plutôt que de les subir, 
              tu vas les <span className="text-gold-luminous">surfer avec aisance et légèreté</span>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FrequenciesSection;
